import React from "react";

export default function MSAccess_DateSerial() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_DateSerial</h1>
      <p>This is the MSAccess_DateSerial component generated from the SQL JSON.</p>
    </div>
  );
}
